import { render, staticRenderFns } from "./VehicleAppsDetailList.vue?vue&type=template&id=0c64a7ea"
import script from "./VehicleAppsDetailList.vue?vue&type=script&lang=js"
export * from "./VehicleAppsDetailList.vue?vue&type=script&lang=js"
import style0 from "./VehicleAppsDetailList.vue?vue&type=style&index=0&id=0c64a7ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports